export enum ShareModalPlatforms {
  INSTAGRAM,
  SNAPCHAT,
}
